import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import {Link} from 'react-router';
import Helmet from 'react-helmet';
import Spinner from '../../components/svg/spinner';
import { newsRoute } from '../../routes/index';
import css from './news.scss';
import { formatNumber, DateFormatter } from '../../utils/date';
import forEach from 'lodash/forEach';

import connect from '../../utils/connect';

import { fetchNews } from '../../actions/news';

//import css from './editorial.scss';

class News extends Component {

	constructor(props) {
		super();

		this.state = {
			searchWord: '',
			searchResults: [],
		};
	}

	componentWillMount() {
		this.fetchNews = bindActionCreators(fetchNews, this.props.dispatch);

		this.fetchNews();
	}

	componentWillReceiveProps(nextProps) {
	}

	shouldComponentUpdate(nextProps, nextState) {
		return (
			nextProps.browser.window.width !== this.props.browser.window.width ||
			nextProps.news.news.length !== this.props.news.news.length ||
			nextState !== this.state
		);

		// update on init
		// if ((!this.props.items.length && nextProps.items.length)) {
		// 	return true;
		// }
	}

	render() {
		let news = this.props.news.news;
		let allJobs = 'All news';
		let jobsNum = news.length;

		let searchWord = this.state.searchWord;
		let searchResults = [];

		searchWord = searchWord.toLowerCase();

		forEach(news, function(single) {
			let date = new DateFormatter(single.createdDate);
			date = date.date + ' ' + date.month + ' ' + date.year;
			if (date.toLowerCase().indexOf(searchWord) > -1  || single.title.toLowerCase().indexOf(searchWord) > -1 || single.users.name && single.users.name.toLowerCase().indexOf(searchWord) > -1) {
				searchResults.push(single);
			}
		});

		if (searchWord != '') {
			jobsNum = searchResults.length;
			allJobs = 'Found news';

			if (!searchResults.length) {
				searchResults.push({
					title: 'No results',
				});
			}
		}

		return (
			<div>
			<Helmet title='News - The FWA' />
			{news.length && (
				<article className='news-list span14'>
					<div className='news-list__top span14'>
						<h1 className='news-list__top__title'>News</h1>
						<span className='news-list__top__number'> ({news.length})</span>
					</div>
					<input onChange={(event)=>this.onInput(event)} className='news-list__search span12 pixel-pattern hide-mobile' type='text' placeholder='Search for news...'/>
					<div className='span2 news-list__right--small hide-mobile'>
						<span className='news-list__right__byline'>showing</span>
						<h2 className='news-list__right__title'>{allJobs}</h2>
						<span className='news-list__right__number'>{jobsNum + ' in total'}</span>
					</div>
					<div className='news-list__flex'>
						{searchResults && (
						<ul className='news-list__news span12 span14-mobile'>
							{searchResults.map((news, i) => this.renderNewsSingle(news, i))}
						</ul>
						) || (
						<ul className='news-list__news span12 span14-mobile'>
							{news.map((news, i) => this.renderNewsSingle(news, i))}
						</ul>
						)}
						<div className='span2 news-list__right hide-mobile'></div>
					</div>
				</article>
				) || (
				<Spinner className='case-single__spinner' size='80px'></Spinner>
				)
			}
			</div>
		);
	}

	onInput(e) {
		this.setState({
			...this.state,
			searchWord: e.target.value,
		});
	}

	renderNewsSingle(single, i) {
		let uid = 'news-' + i;
		let date = new DateFormatter(single.createdDate);
		date = date.date + ' ' + date.month + ' ' + date.year;
		let url = newsRoute(single.slug);

		return (
			<li key={uid} className='news-list__news__news-single span4 span6-tablet span14-mobile'>
				<h2 className='news-list__news__news-single__title span3 span5-tablet span12-mobile'>{single.title}</h2>
				{single.users && single.users.name && (
				<span className='news-list__news__news-single__profile'>{'By ' + single.users.name}</span>
				)}
				{single.createdDate && (
				<span className='news-list__news__news-single__date'>{date}</span>
				)}
				{single.slug && (
				<div className='news-list__news__news-single__overlay'><Link to={url} className='button news-list__news__news-single__button'>Read more</Link></div>
				)}
			</li>
		);
	}
}

export default connect(News);



/** WEBPACK FOOTER **
 ** ./frontend/containers/news/news.js
 **/